/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupLicenseAgreementsRoutingModule } from './builder-setup-license-agreements-routing.module';
import { LicenseAgreementDetailsComponent } from './components/license-agreement-details/license-agreement-details.component';
import { LicenseAgreementListComponent } from './components/license-agreement-list/license-agreement-list.component';
import { LicenseAgreementDetailsBusinessService } from './resources/license-agreement-details-business.service';
import { LicenseAgreementListBusinessService } from './resources/license-agreement-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupLicenseAgreementsRoutingModule,
  ],
  providers: [
    LicenseAgreementDetailsBusinessService,
    LicenseAgreementListBusinessService,
  ],
  declarations: [
    LicenseAgreementDetailsComponent,
    LicenseAgreementListComponent,
  ],
})
export class BuilderSetupLicenseAgreementsModule {
}
